import { getRewardRouteToInfoPage } from '@/common/reward/route.registry';
import { InjectionFeature, RewardItem } from '@/common/reward/types';

function getRewardLinkableItem(items: RewardItem[], data: number, feature: number) {
    if (feature === InjectionFeature.CreditTicket) {
        return new RewardItem(feature, data, `${data} chip(s)`);
    }

    return items.find(item => item.itemId === data && item.feature === feature) ?? new RewardItem();
}

export function decorateReward<T extends { data: number; feature: number }>(reward: T, items: RewardItem[]) {
    const linkableItem = getRewardLinkableItem(items, reward.data, reward.feature);

    return {
        ...reward,
        itemName: linkableItem.itemName,
        itemLink: getRewardRouteToInfoPage(linkableItem.feature, linkableItem.itemId)
    };
}
